import React, { ReactElement } from "react";
import { ListingItem } from "@lib/shared/types";
import ListingBlock from "../listingBlock";
import { AffiliateOfferZone } from "@lib/shared/config";

export default function Listing({
    listing,
    zone,
}: {
    listing: ListingItem[] | undefined;
    zone: AffiliateOfferZone;
}): ReactElement {
    return (
        <div>
            {listing?.map((item, index) => (
                <ListingBlock
                    zone={zone}
                    key={item.id}
                    item={item}
                    index={index}
                />
            ))}
        </div>
    );
}
